import React from 'react';
import { UserX } from 'lucide-react';

const MSG = 'Your account is not linked to an employee profile. Please contact your administrator to link your user account in HR & Payroll → Employees.';

// True when the backend says the logged-in user has no linked employee row.
export const isNotLinked = (err) => String(err?.response?.data?.detail || '').startsWith('Your account is not linked');

export const NotLinkedNotice = ({ show }) => (show ? (
  <div className="flex items-start gap-2 rounded-lg border border-amber-300 bg-amber-50 p-3 text-xs text-amber-900" data-testid="not-linked-notice">
    <UserX size={14} className="mt-0.5 shrink-0" />
    <span>{MSG}</span>
  </div>
) : null);
